export default {
    methods: {
        notify(response) {
            //Verifico sia stato passato un codice
            if (response == undefined)
                return;

            if (response.notification != undefined)
                this.$toasted.show(response.notification.message, {
                    className: "bubble-" + this.getNotificationClass(response.code),
                })
            
            if (response.redirect != undefined)
                this.redirect(response.redirect.url);            
        },

        /*
        1xx -> Internal error -> class: warning, icon: fas fa - exclamation - triangle
        2xx -> Success -> class: success, icon: fas fa - check
        3xx -> Data already exists -> class: danger, icon: fas fa - times
        4xx -> Data not found -> class: dark, icon: fas fa - info - circle
        5xx -> Unauthorized access -> class: danger, icon: fas fa - times
        6xx -> Operation is not allowed -> class: danger, icon: fas fa - times
        7xx -> Incorrect Data(formato) -> class: danger, icon: fas fa - times
        8xx -> Invalid(value) -> class: danger, icon: fas fa - times
        */
        getNotificationClass(code) {
            switch (code) {
                case 100: return "warning";
                case 200: return "success";
                case 300: return "danger";
                case 400: return "dark";
                case 500: return "danger";
                case 600: return "danger";
                case 700: return "danger";
                case 800: return "danger";
            
                default: return "dark";
            }            
        },

        redirect(url) {
            this.$router.push({ name: url });
        }
    }
}

